import { common } from '../common.js';
import type { IProgram } from '../types.js';

export const H_AND_C: IProgram = {
  id: 'humanitarian-compassionate',
  name: 'Permanent residence on humanitarian and compassionate grounds',
  short: 'H&C',
  family: 'humanitarian',
  status: 'active',
  version: '2026-10-04',
  review: 'pending',
  sources: [{ title: 'IRCC Guide 5291: Humanitarian and compassionate considerations', url: 'https://www.canada.ca/en/immigration-refugees-citizenship/services/application/application-forms-guides/guide-5291-humanitarian-compassionate-considerations.html', retrieved: '2026-10-04' }],
  questions: [
    { id: 'children', text: 'Are the best interests of a child affected?', kind: 'yesno' }
  ],
  roles: [
    { id: 'principal', label: 'Applicant', min: 1, max: 1 },
    { id: 'spouse', label: 'Spouse or common-law partner', min: 0, max: 1 },
    { id: 'dependant', label: 'Dependent child', min: 0, max: 15 }
  ],
  sections: ['Forms', 'Humanitarian factors', 'Identity and civil documents', 'Photos and police certificates', 'Fees'],
  items: [
    { id: 'personalChecklist', label: 'IRCC document checklist for the H&C application', section: 'Forms', forRoles: 'application', source: 0 },
    { id: 'imm0008', label: 'Generic Application Form for Canada', form: 'IMM 0008', section: 'Forms', forRoles: ['principal'], source: 0 },
    { id: 'imm5669', label: 'Schedule A, Background/Declaration', form: 'IMM 5669', section: 'Forms', forRoles: ['principal', 'spouse', 'dependant'], minAge: 18, source: 0 },
    { id: 'imm5406', label: 'Additional Family Information', form: 'IMM 5406', section: 'Forms', forRoles: ['principal', 'spouse', 'dependant'], minAge: 18, source: 0 },
    { id: 'imm5283', label: 'Supplementary Information, Humanitarian and Compassionate Considerations', form: 'IMM 5283', section: 'Forms', forRoles: ['principal'], source: 0 },
    common.representative(0),
    { id: 'submissions', label: 'Written submissions on the humanitarian factors', section: 'Humanitarian factors', forRoles: 'application', source: 0 },
    { id: 'establishment', label: 'Proof of establishment in Canada (work, studies, community, family ties)', section: 'Humanitarian factors', forRoles: ['principal'], source: 0 },
    { id: 'hardship', label: 'Evidence of the hardship of leaving Canada', section: 'Humanitarian factors', forRoles: 'application', source: 0, translationIfNotEnFr: true },
    { id: 'bestInterests', label: 'Evidence about the best interests of each child affected', section: 'Humanitarian factors', forRoles: 'application', when: { q: 'children', is: true }, source: 0 },
    common.passport(0, ['principal', 'spouse', 'dependant']),
    common.photos(0, ['principal', 'spouse', 'dependant']),
    common.police(0, ['principal', 'spouse', 'dependant']),
    common.translations(0),
    common.fees(0)
  ],
  deadlines: []
};
